import type { SessionResponse, Session } from '../types/index';
import { API_BASE_URL } from '../utils/constants';

const API_URL = `${API_BASE_URL}/api/sessions`;

export async function createSession(): Promise<SessionResponse> {
  const response = await fetch(API_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (!response.ok) {
    throw new Error(`Failed to create session: ${response.statusText}`);
  }

  return response.json();
}

export async function getSession(sessionId: string): Promise<Session> {
  const response = await fetch(`${API_URL}/${sessionId}`);

  if (!response.ok) {
    if (response.status === 404) {
      // Don't log 404 errors - they're expected when sessions expire
      const error = new Error('Session not found or expired');
      (error as any).isExpected = true;
      throw error;
    }
    throw new Error(`Failed to get session: ${response.statusText}`);
  }

  return response.json();
}

export async function updateStory(
  sessionId: string,
  facilitatorToken: string,
  story: string,
): Promise<void> {
  const response = await fetch(`${API_URL}/${sessionId}/story`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      facilitatorToken,
      story,
    }),
  });

  if (!response.ok) {
    throw new Error(`Failed to update story: ${response.statusText}`);
  }
}

export interface AdminSession {
  id: string;
  facilitatorName: string;
  participantCount: number;
  minutesUntilExpiry: number;
  isExpired: boolean;
  createdAt: number;
  expiresAt: number;
  state: 'collecting' | 'revealed';
}

export interface AdminSessionsResponse {
  sessions: AdminSession[];
}

export async function getAllActiveSessions(): Promise<AdminSessionsResponse> {
  const response = await fetch(`${API_BASE_URL}/api/admin/sessions`);

  if (!response.ok) {
    throw new Error(`Failed to get active sessions: ${response.statusText}`);
  }

  return response.json();
}

export async function deleteSession(sessionId: string): Promise<void> {
  const response = await fetch(`${API_BASE_URL}/api/admin/sessions/${sessionId}`, {
    method: 'DELETE',
  });

  if (!response.ok) {
    throw new Error(`Failed to delete session: ${response.statusText}`);
  }
}

